import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { sortLiveSessionsCallback } from "@data/utility/dataUtils"
import { useNavigation } from "@react-navigation/native"
import React from "react"
import { connect } from "react-redux"
import { TutorNextEventsCard } from "../home/interview/TutorNextEventsCard"
import TutorLiveCardComponent from "./TutorLiveCardComponent"

function TutorNextLivesCard(props) {
    const liveSessions = props.user?.live_sessions?.sort(
        sortLiveSessionsCallback
    )

    const navigation = useNavigation()
    return (
        <TutorNextEventsCard
            title={"Mes prochains lives"}
            data={liveSessions}
            renderItem={(ls, key, additionalOnPress = () => {}) => {
                const item = ls

                return (
                    <TutorLiveCardComponent
                        key={item?.id}
                        navigation={navigation}
                        liveSession={item}
                        additionalOnPress={additionalOnPress}
                    />
                )
            }}
        />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        students: state.data.currentUser?.object?.students,
        getStudentRequest: state.api.getStudents?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
}

export default connect(mapStateToProps, mapDispatchToProps)(TutorNextLivesCard)
